import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";

import { Button } from "components/Button";
import Text from "components/Text";
import InlineModal from "components/shared/InlineModal";

import styles from "./NotFound.scss";

const NotFound = () => {
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  return (
    <InlineModal
      data-non-routed-modal-name="NotFound"
      heading={<Text t="errors.not_found" />}
      onClose={goBack}
    >
      <div className={styles.actions}>
        <Button onClick={goBack}>
          <Text t="helpers.links.back" />
        </Button>
      </div>
    </InlineModal>
  );
};

export default NotFound;
